import React from 'react';
import Button from '@ids/button';

function ResourceCenterFooter() {
  return (
    <div className="bottomBannar">
      <div className="bottomBannarHeading">DON’T BE A VICTIM OF FRAUD</div>
      <p>Get the products you need to help keep your business safe.</p>
      <a href="/secure-products">
        <Button className="view-all-product-btn" theme="intuit" styleOverrideReason="none">
          View All Products
        </Button>
      </a>
    </div>
  );
}

export default ResourceCenterFooter;
